import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        console.debug("[VetterCare] form_controller connected to:", this.element);
        // Listen for Turbo events to hide spinner and show toast
        document.addEventListener("turbo:submit-end", this.handleTurboSubmitEnd);
    }

    disconnect() {
        document.removeEventListener("turbo:submit-end", this.handleTurboSubmitEnd);
    }

    handleTurboSubmitEnd = (event) => {
        // Only handle the profile visibility form
        const form = document.getElementById("profile-visibility-form");
        if (!form || event.target !== form) return;
        // Hide spinner
        const spinner = document.getElementById("profile-visibility-spinner");
        if (spinner) spinner.classList.add("d-none");
        // Show toast for success or error
        if (event.detail.success) {
            this.showToast("Profile visibility updated!", "success");
        } else {
            this.showToast("Failed to update visibility.", "danger");
        }
    }

    showToast(message, type = "success") {
        // Create a toast element if not present
        let toast = document.getElementById("profile-visibility-toast");
        if (!toast) {
            toast = document.createElement("div");
            toast.id = "profile-visibility-toast";
            toast.className = `toast align-items-center text-bg-${type} border-0 position-fixed top-0 end-0 m-4`;
            toast.style.zIndex = 2000;
            toast.innerHTML = `<div class='d-flex'><div class='toast-body'>${message}</div><button type='button' class='btn-close btn-close-white me-2 m-auto' data-bs-dismiss='toast' aria-label='Close'></button></div>`;
            document.body.appendChild(toast);
        } else {
            toast.querySelector('.toast-body').textContent = message;
            toast.className = `toast align-items-center text-bg-${type} border-0 position-fixed top-0 end-0 m-4`;
        }
        // Show the toast (Bootstrap 5)
        const bsToast = bootstrap.Toast.getOrCreateInstance(toast, { delay: 2000 });
        bsToast.show();
    }
}